const MissionTypes = {
    Main: 'main',
    Additional: 'additional',
} as const;

export default MissionTypes;
